<!-- Spacer -->
<div
    class="cipafacil-horizontal-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
